/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Music mood
 * @export
 */
export const Mood = {
    Peaceful: 'Peaceful',
    Romantic: 'Romantic',
    Sentimental: 'Sentimental',
    Tender: 'Tender',
    Easygoing: 'Easygoing',
    Yearning: 'Yearning',
    Sophisticated: 'Sophisticated',
    Sensual: 'Sensual',
    Cool: 'Cool',
    Gritty: 'Gritty',
    Melancholy: 'Melancholy',
    Serious: 'Serious',
    Brooding: 'Brooding',
    Fiery: 'Fiery',
    Defiant: 'Defiant',
    Aggressive: 'Aggressive',
    Rowdy: 'Rowdy',
    Excited: 'Excited',
    Energizing: 'Energizing',
    Empowering: 'Empowering',
    Stirring: 'Stirring',
    Upbeat: 'Upbeat',
    Other: 'Other'
} as const;
export type Mood = typeof Mood[keyof typeof Mood];


export function MoodFromJSON(json: any): Mood {
    return MoodFromJSONTyped(json, false);
}

export function MoodFromJSONTyped(json: any, ignoreDiscriminator: boolean): Mood {
    return json as Mood;
}

export function MoodToJSON(value?: Mood | null): any {
    return value as any;
}

